<mat-card>
  <h2 translate>passwordPolicy.title</h2>
  <mat-card-content>
    <div class="table__wrapper">
      <table aria-label="passwordPolicy" mat-table [dataSource]="data">
        <ng-container matColumnDef="text">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">{{ element.text }}</td>
        </ng-container>
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            {{ element.value }}
          </td>
        </ng-container>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
<div class="btnBack">
  <button id="backPasswordPolicy" mat-flat-button color="accent" (click)="returnHome()">
    {{ 'passwordPolicy.back' | translate | uppercase }}
  </button>
</div>
